// Screen enum for navigation
export const Screen = {
  Splash: 'SPLASH',
  Login: 'LOGIN',
  Home: 'HOME',
  Consent: 'CONSENT',
  VerificationMethod: 'VERIFICATION_METHOD',
  AadhaarEKYC: 'AADHAAR_EKYC',
  AadhaarDocument: 'AADHAAR_DOCUMENT',
  ApplicantDetails: 'APPLICANT_DETAILS',
  FaceMatch: 'FACE_MATCH',
  FinalOTPVerification: 'FINAL_OTP_VERIFICATION',
  PurposeOfVisit: 'PURPOSE_OF_VISIT',
  ApplicationType: 'APPLICATION_TYPE',
  GroupApplication: 'GROUP_APPLICATION',
  AddMember: 'ADD_MEMBER',
  PermitValidity: 'PERMIT_VALIDITY',
  Payment: 'PAYMENT',
  PaymentSuccess: 'PAYMENT_SUCCESS',
  Success: 'SUCCESS',
  MyPermits: 'MY_PERMITS',
  Map: 'MAP',
  ViewPermit: 'VIEW_PERMIT'
};

// Default user data
export const defaultUserData = {
  name: '',
  aadhaar: 'XXXX-XXXX-XXXX',
  fatherName: '',
  dob: '',
  gender: '',
  mobile: '+91 XXXXX XXXXX',
  address: '',
  photoUrl: ''
};

